import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const BASE_URL = "https://newalemny.3almny.app/api";

// Async thunk for submitting contact form
export const submitContactForm = createAsyncThunk(
  'contactUs/submitForm',
  async (contactData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/contact_us`, contactData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'حدث خطأ في إرسال الرسالة'
      );
    }
  }
);

const initialState = {
  isSubmitting: false,
  submitSuccess: false,
  submitError: null,
  submittedData: null
};

const contactUsSlice = createSlice({
  name: 'contactUs',
  initialState,
  reducers: {
    resetContactForm: (state) => {
      state.isSubmitting = false;
      state.submitSuccess = false;
      state.submitError = null;
      state.submittedData = null;
    },
    clearSubmitError: (state) => {
      state.submitError = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(submitContactForm.pending, (state) => {
        state.isSubmitting = true;
        state.submitError = null;
        state.submitSuccess = false;
      })
      .addCase(submitContactForm.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.submitSuccess = true;
        state.submittedData = action.payload;
        state.submitError = null;
      })
      .addCase(submitContactForm.rejected, (state, action) => {
        state.isSubmitting = false;
        state.submitSuccess = false;
        state.submitError = action.payload;
      });
  }
});

export const { resetContactForm, clearSubmitError } = contactUsSlice.actions;
export default contactUsSlice.reducer;
